import { gql } from '@apollo/client';

export const FETCH_RECENT_BOOKINGS = gql`
  query GetRecentBookings($lastDay: timestamptz!, $productId: String!) {
    boatnew_booking(
      order_by: { created_at: desc }
      where: {
        _and: [
          { product_id: { _eq: $productId } }
          { created_at: { _gte: $lastDay } }
        ]
      }
    ) {
      id
      created_at
      product_id
      product {
        id
        name
      }
    }
  }
`;
